(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["product-addons"] && !Shopify.designMode) return;
  try {
    class ProductAddonsGroup extends HTMLElement {
    #selectedValue = '';
    #selectedImg = '';

    connectedCallback() {
      const btn        = this.querySelector('[data-addon-btn]');
      const trigger    = this.querySelector('[data-addon-trigger]');
      const triggerImg   = this.querySelector('[data-addon-trigger-img]');
      const triggerTxt   = this.querySelector('[data-addon-trigger-text]');
      const triggerPrice = this.querySelector('[data-addon-trigger-price]');
      const listbox      = this.querySelector('[data-addon-listbox]');
      const mainImg    = this.querySelector('.product-addons-group__img img');

      if (!btn || !trigger || !listbox) return;

      if (mainImg) mainImg.removeAttribute('srcset');

      // Toggle open/close
      trigger.addEventListener('click', () => {
        const open = trigger.getAttribute('aria-expanded') === 'true';
        trigger.setAttribute('aria-expanded', String(!open));
        listbox.classList.toggle('is-open', !open);
      });

      // Close on outside click
      document.addEventListener('click', (e) => {
        if (!this.contains(e.target)) this.#close(trigger, listbox);
      });

      // Option selection
      listbox.querySelectorAll('.product-addons-group__option').forEach(opt => {
        opt.addEventListener('click', () => {
          // Clear previous selection
          listbox.querySelectorAll('[aria-selected="true"]')
            .forEach(o => o.setAttribute('aria-selected', 'false'));

          opt.setAttribute('aria-selected', 'true');
          this.#selectedValue = opt.dataset.value;
          this.#selectedImg   = opt.dataset.img || '';

          // Update trigger label, price + thumbnail
          triggerTxt.textContent = opt.dataset.title;
          if (triggerPrice) triggerPrice.textContent = opt.dataset.price || '';
          if (this.#selectedImg) {
            let tImg = triggerImg.querySelector('img');
            if (!tImg) {
              tImg = document.createElement('img');
              tImg.width = 28; tImg.height = 28;
              tImg.alt = '';
              triggerImg.appendChild(tImg);
            }
            tImg.src = this.#selectedImg;
            triggerImg.classList.add('is-visible');
          }

          // Update main thumbnail
          if (mainImg) mainImg.src = this.#selectedImg || mainImg.getAttribute('src');

          this.#close(trigger, listbox);
        });
      });

      // Add button
      btn.addEventListener('click', async () => {
        if (!this.#selectedValue) { trigger.focus(); return; }
        btn.disabled = true;
        const orig = btn.textContent.trim();
        btn.textContent = '...';
        try {
          const msgEl = this.querySelector('[data-addon-message]');
          const message = msgEl ? msgEl.value.trim() : '';
          await fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
              items: [{
                id: parseInt(this.#selectedValue),
                quantity: 1,
                ...(message && { properties: { [msgEl.getAttribute('aria-label')]: message } })
              }]
            }),
          });
          const cart = await fetch('/cart.js').then(r => r.json());
          const event = new Event('cart:update', { bubbles: true });
          event.detail = { data: { itemCount: cart.item_count } };
          document.dispatchEvent(event);
          btn.textContent = '✓ Added';
          btn.setAttribute('data-added', '');
          setTimeout(() => {
            btn.textContent = orig;
            btn.removeAttribute('data-added');
            btn.disabled = false;
          }, 2000);
        } catch (e) {
          btn.textContent = orig;
          btn.disabled = false;
        }
      });
    }

    #close(trigger, listbox) {
      trigger.setAttribute('aria-expanded', 'false');
      listbox.classList.remove('is-open');
    }
  }
  customElements.define('product-addons-group', ProductAddonsGroup);
  } catch(e) { console.error(e); }
})();

})();
